<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2 style="word-break: initial;">Actualizar Contraseña</h2>
      <div class="flex-grow-1"></div>
    </v-card-title>
    <v-form class="mx-10" @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
      <v-card flat>
        <v-toolbar color="grey" dark dense flat>
          <h3>{{ currentUser.nombre.toUpperCase() }}</h3>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.nombre+ ' ' + currentUser.primer_apellido + ' ' + (currentUser.segundo_apellido !=null ? currentUser.segundo_apellido : '')"
                label="Nombre"
                prepend-icon="mdi-account"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.email"
                label="Email"
                prepend-icon="mdi-email"
                readonly
                >
              </v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.cargo"
                label="Cargo"
                prepend-icon="mdi-account"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.adscripcion"
                label="Adscripción"
                prepend-icon="mdi-account"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row> -->
          <v-flex xs12>
            <v-checkbox
              v-model="changePassword"
              label="Cambiar Contraseña"
            ></v-checkbox>
          </v-flex>
          <v-row v-if="changePassword">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="pass.current_password"
                :append-icon="showcurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Contraseña Actual"
                :type="showcurrentPassword ? 'text' : 'password'"
                counter
                @click:append="showcurrentPassword = !showcurrentPassword"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="changePassword">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="pass.new_password"
                :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Nueva Contraseña"
                :type="shownewPassword ? 'text' : 'password'"
                counter
                @click:append="shownewPassword = !shownewPassword"
                :rules="[v => v.length >= 8 || 'Requiere mínimo 8 caracteres']"
                minlength="8"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="pass.newPassword_confirmation"
                :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Confirmar Nueva Contraseña"
                :type="shownewPassword ? 'text' : 'password'"
                counter
                @click:append="shownewPassword = !shownewPassword"
                :rules="[this.pass.new_password === this.pass.newPassword_confirmation || 'Las contraseñas no coinciden']"
                minlength="8"
                counter=""
              ></v-text-field>
            </v-col>

          <v-divider></v-divider>
          <v-btn block color="primary" @click="cambiarPassword()" class="my-5" :disabled="!valid">
            Actualizar Contraseña
            <!-- <v-icon>mdi-content-save</v-icon> -->
          </v-btn>
        </v-row>
        </v-card-text>
      </v-card>
    </v-form>
    <br>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');

  export default {
    data: () => ({
      valid: true,
      changePassword:false,
      currentPassword: false,
      pass:{
        current_password:'',
        new_password:'',
        newPassword_confirmation:'',
      },
      defaultData:{
        current_password:'',
        new_password:'',
        newPassword_confirmation:'',
      },
      // newPassword:'',
      // confirmPassword:'',
      showcurrentPassword: '',
      shownewPassword: ''
    }),
    created() {
      this.$store.commit("SET_LAYOUT", "dashboard-layout");
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "isLoggedIn"
      ])
    },
    methods: {
      cambiarPassword(pass) {
        if (this.isLoggedIn && this.$refs.form.validate()) {
          this.$store.dispatch("ACTUALIZAR_PASSWORD", { url:"/user/updatePassword", data:this.pass } ).then(response => {
            if(response.data.status == 'ok'){
              Swal.fire({
                icon: 'success',
                title: 'Contraseña actualizada correctamente',
                confirmButtonText: "Aceptar"
              })
              this.reset();
            }
          })
          .catch(error => {
            console.log(error.response);
            Swal.fire({
              icon: 'error',
              title: "Error",
              text: error.response.data.errors,
              confirmButtonText: "Aceptar"
            })
          });
        }
      },
      reset() {
      this.pass = Object.assign({}, this.defaultData)
      this.changePassword=false
      },
    }
  };
</script>
